import { examsRouting } from './../../report/paper-set.routes';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ShoppingCartService, CustomObserverService, CookieManagerService, HttpClientService, ErrorManagerService, LoginRedirectService } from '../../../shared/';
import { CookieNames, ApiEndpoints, BasicRoutes, ErrorText, PaymentSteps, redirectionPoints } from '../../constant';
import { NewUser } from './../../model/newUser';

declare var $: any;

@Component({
  selector: 'app-checkout',
  templateUrl: '../views/checkout.component.html',
  styleUrls: ['../../../css/home.component.css']
})
export class CheckoutComponent implements OnInit {

  public totalPrice: number = 0;
  public ItemsCheckout: Array<any>;
  public removeItemId: number = 0;
  public discountPrice = 0; // haveto change
  public lengthItems: number = 0;
  public loginModal;
  private user: any;
  public userDetails: NewUser = new NewUser({});
  public username: boolean = false;
  public billingDetails: boolean = true;
  public errorMessage: string;
  public errorText: string;
  public discountPriceAmount: number = 0;
  public totalPriceAmount:number = 0;
  public apiRequstWaiter: boolean = true;
  

  constructor(
    private router: Router,
    private shoppingCartService: ShoppingCartService,
    private customObserverService: CustomObserverService,
    private cookieManagerService: CookieManagerService,
    private httpClientService: HttpClientService,
    private ErrorManagerService: ErrorManagerService,
    private translateService: TranslateService,
    private loginRedirectService : LoginRedirectService,
  ) {
    this.shoppingCartService.getItemsLength()
      .subscribe(res => {
        if (res != null) {
          this.getCartItems();
          this.lengthItems = res.length;
          if (this.lengthItems == 0) {
            this.router.navigate(['home/exams']);
          }
        }
      });
  }

  ngOnInit() {
    this.customObserverService.setPaymentFlowIcon( PaymentSteps.cart);
    this.getOfferDetails(true,(error, callbackId) => {
      this.getMyBageDetails();
    });
    window.scrollTo(0, 0);
  }

  payment(id) {
    this.router.navigate(['home/exams/' + 1 + '/payment']);
    this.customObserverService.setPaymentFlowIcon(PaymentSteps.cart);
  }

  ngAfterViewInit() {
    this.loginModal = $('#log-in-pop');
  }
  /**
   * kaushalya
   * 2017-10-16
   * get the cart details
   */
  getMyBageDetails() {
    this.ItemsCheckout = this.shoppingCartService.allStorage();
    // this.totalPrice = this.shoppingCartService.returnTotalPrice();
    this.totalPriceAmount = this.shoppingCartService.returnTotalPrice();
    this.lengthItems = this.ItemsCheckout.length;
    this.discountPriceAmount = this.totalPriceAmount * this.discountPrice / 100
    this.totalPrice = this.totalPriceAmount - this.discountPriceAmount;
  }

  /**
   * kauhslya
   * 2017-10-16
   * load the confermation alert for removiing
   */
  removeItemModalload(type, itemId) {
    if (type) {
      this.removeItemId = itemId;
      $('#deleteConfermation-model').modal('show');
    } else {
      $('#deleteConfermation-model').modal('hide');
      this.shoppingCartService.removeItemsCheckout(this.removeItemId);
      this.getMyBageDetails();
      this.removeItemId = 0;
    }
  }
  getCartItems() {
    this.shoppingCartService.itemsCheckout.subscribe((response) => {
      this.ItemsCheckout = response;
      this.totalPrice = this.shoppingCartService.returnTotalPrice();
    });
  }

  getUser() {
    let userObj = this.cookieManagerService.getCookie(CookieNames.userobj, false);

    this.user = userObj ? JSON.parse(userObj.toString()) : null;
    if (this.user) {
      this.username = true;
    }
  }
  navigate(url) {
    this.apiRequstWaiter = false;
    this.getUser();
    if (url == BasicRoutes.billingInfo && !this.username) {
      this.apiRequstWaiter = true;
      $('#log-in-pop').modal('show');
      this.loginRedirectService.setRedirectPoint(redirectionPoints.billingInfo);
      return;
    }
    else {
      this.getUserById(this.cookieManagerService.getCookie(CookieNames.username, false), (error, billingDetails) => {
        if (billingDetails) { // if user details exit redirect to payment
          this.router.navigate([BasicRoutes.paymentOptions]);
          this.customObserverService.setPaymentFlowIcon(PaymentSteps.paymentOptions);
        } else { // redirect to billing
          this.router.navigate([url]);
          this.customObserverService.setPaymentFlowIcon(PaymentSteps.billingDetails);
        }
      });
    }
    this.shoppingCartService.getPageStatus()
    .subscribe(res => {
      if (res) {
        this.apiRequstWaiter = res;
      }
    });
  }

  navigateback(url) {
    this.router.navigate([url]);
  }

  /**
   * get User By Id
   * @param {any} id
   * @param {any} callback
   * kaushalya
   * 2017-10-24
   */
  getUserById(id, callback) {

    this.httpClientService.authGet(ApiEndpoints.getUserById, null).subscribe(response => {

      this.userDetails = new NewUser(response.user);

      if (this.userDetails.setting.mobile && this.userDetails.setting.mobile.length > 0) {
        // this.billingMobile = this.user.setting.mobile[this.user.setting.mobile.length - 1].data;
      }
      else {
        this.billingDetails = false;
      }
      if (!this.userDetails.grade) {
        this.billingDetails = false;
      }
      if (!this.userDetails.district) {
        this.billingDetails = false;
      }
      callback(null, this.billingDetails);

    }, error => {
      callback(null, false);
    });
  }

  getOfferDetails(val,callback) {

    this.httpClientService.get(ApiEndpoints.offerImage).subscribe(response => {
      if (Object.keys(response).length != 0) {
        if (response && response.isDiscountOffer && !response.isAnnouncement) {
          this.discountPrice = response.discountRate
        }
      }
      callback(null, this.discountPrice);
    });
    callback(null, this.discountPrice);
  }
}


// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/checkout/components/checkout.component.ts